import {DeleteOutlined} from '@ant-design/icons';
import {Button, message, Popconfirm} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useMutation} from 'react-query';

export const createDeleteMany = (service, name, translation) => {
  const DeleteManyButton = ({items, onDelete}) => {
    const {t} = useTranslation(translation);
    const {mutateAsync, isLoading} = useMutation(service);
    const hasItems = !!items;

    const handleRemove = useCallback(async () => {
      if (hasItems) {
        try {
          await mutateAsync(items);
          message.success(t('deleteManySuccess'));
          onDelete && onDelete();
        } catch (e) {
          message.error('Error');
        }
      }
    }, [hasItems, mutateAsync, items, t, onDelete]);

    return (
      <Popconfirm
        placement="bottomRight"
        title={t(items?.length && items?.length > 1 ? 'manyDeleteConfirmation' : 'deleteConfirmation')}
        onConfirm={handleRemove}
        okText={t('delete')}
        cancelText={t('cancel')}
      >
        <Button size={'small'}
          disabled={isLoading || !hasItems}
          loading={isLoading}
          type="link"
          danger
          icon={<DeleteOutlined/>}>
          {t('remove')}
        </Button>
      </Popconfirm>
    );

  };

  DeleteManyButton.propTypes = {
    onDelete: PropTypes.func,
    items: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
  };

  return memo(DeleteManyButton);
};
